export enum BuyType {
  Voucher = "voucher",
  Card = "card",
}

export enum CardType {
  NewCard = "new-card",
}
